import Grid from '@mui/material/Grid2';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { useFormContext } from 'react-hook-form-mui';
import RenderSelectField from '../../../../Utilities/Forms/RenderSelectField';
import RenderTextField from '../../../../Utilities/Forms/RenderTextField';
import ValidatedSelectElement from '../../../../Utilities/Forms/ValidatedSelectElement';
import ValidatedTextField from '../../../../Utilities/Forms/ValidatedTextField';
import monthDropdown from '../../../../Utilities/Constants/MonthDropdown';
import yesNoDropdown from '../../../../Utilities/Constants/YesNoDropdown';
interface IProps {
    isReadOnly: boolean
}
export default function TravelPlanShuttleBusV1({ isReadOnly }: IProps) {
    const { getValues } = useFormContext();
    const formValues = getValues();
    const hasValues = (fields: string[]) => fields.some(field => formValues[field]) || !isReadOnly;
    return (
        <>
            <Grid container alignItems="flex-start">
                <Grid size={4} container>
                    {hasValues(["shuttleBusServiceToResidentialAreas", "shuttleBusServiceToResidentialAreasMonth", "shuttleBusServiceToResidentialAreasYear", "shuttleBusServiceToResidentialAreasCapitalCost", "shuttleBusServiceToResidentialAreasAnnualCost"]) && (
                        <Grid container size={12}>
                            <RenderSelectField name="shuttleBusServiceToResidentialAreas" label="Shuttle bus(es) to main staff/customer residential areas" readOnly={isReadOnly} options={yesNoDropdown} />
                            <Grid container size={12}>
                                <Grid size={12}>
                                    <Typography variant={"body1"}>Date implemented</Typography>
                                </Grid>
                                <Stack direction="row" spacing={1}>
                                    <Grid size={6}>
                                        <ValidatedSelectElement name={'shuttleBusServiceToResidentialAreasMonth'} options={monthDropdown} readOnly={isReadOnly} />
                                    </Grid>
                                    <Grid size={6}>
                                        <ValidatedTextField name={'shuttleBusServiceToResidentialAreasYear'} />
                                    </Grid>
                                </Stack>
                            </Grid>
                            <RenderTextField name="shuttleBusServiceToResidentialAreasCapitalCost" label="Capital cost" readOnly={isReadOnly} />
                            <RenderTextField name="shuttleBusServiceToResidentialAreasAnnualCost" label="Annual operating cost" readOnly={isReadOnly} />
                        </Grid>
                    )}
                </Grid>

                <Grid size={4} container>
                    {hasValues(["shuttleBusServiceToStations", "shuttleBusServiceToStationsMonth", "shuttleBusServiceToStationsYear", "shuttleBusServiceToStationsCapitalCost", "shuttleBusServiceToStationsAnnualCost"]) && (
                        <Grid container size={12}>
                            <RenderSelectField name="shuttleBusServiceToStations" label="Shuttle bus(es) to railway and/or bus station(s)" readOnly={isReadOnly} options={yesNoDropdown} />
                            <Grid container size={12}>
                                <Grid size={12}>
                                    <Typography variant={"body1"}>Date implemented</Typography>
                                </Grid>
                                <Stack direction="row" spacing={1}>
                                    <Grid size={6}>
                                        <ValidatedSelectElement name={'shuttleBusServiceToStationsMonth'} options={monthDropdown} readOnly={isReadOnly} />
                                    </Grid>
                                    <Grid size={6}>
                                        <ValidatedTextField name={'shuttleBusServiceToStationsYear'} />
                                    </Grid>
                                </Stack>
                            </Grid>
                            <RenderTextField name="shuttleBusServiceToStationsCapitalCost" label="Capital cost" readOnly={isReadOnly} />
                            <RenderTextField name="shuttleBusServiceToStationsAnnualCost" label="Annual operating cost" readOnly={isReadOnly} />
                        </Grid>
                    )}
                </Grid>

                <Grid size={4} container>
                    <Grid container size={12}>
                        <Grid size={12}>
                            <Typography variant={"h6"}>Additional comments</Typography>
                        </Grid>
                        <RenderTextField name="shuttleBusServiceComments" readOnly={isReadOnly} multiLine={true} rows={4} inputSize={12} alwaysShow={true} />
                    </Grid>
                </Grid>
            </Grid>

        </>
    );
}
